import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/marketing/Header";
import { toast } from "sonner";

export default function ClientLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.company_name || u.name}`);
      if (u.role === "admin") nav("/admin");
      else if (u.role === "interpreter") nav("/interpreter");
      else nav("/portal");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <form onSubmit={submit} data-testid="client-login-form"
        className="w-full max-w-md space-y-6 bg-white border border-slate-200 rounded-2xl p-10 shadow-sm">
        <Link to="/" data-testid="login-brand"><Logo /></Link>
        <div>
          <h1 className="font-display text-3xl font-medium tracking-tight text-[#0a2540] mt-4">Client Sign In</h1>
          <p className="text-slate-500 mt-2 text-sm">
            Accounts are provisioned by the Interpreta team.{" "}
            <Link to="/contact" className="text-teal-600 font-medium">Contact us</Link> to get started.
          </p>
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required value={email}
            data-testid="client-login-email-input"
            onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" className="h-12" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" required value={password}
            data-testid="client-login-password-input"
            onChange={(e) => setPassword(e.target.value)} className="h-12" />
        </div>
        <Button type="submit" disabled={busy}
          data-testid="client-login-submit-btn"
          className="w-full h-12 rounded-full bg-[#0a2540] hover:bg-[#0a2540]/90 font-semibold">
          {busy ? "Signing in…" : "Sign in"}
        </Button>
        <div className="text-sm text-slate-500 text-center">
          Interpreter?{" "}
          <Link to="/interpreter-login" className="text-teal-600 font-medium" data-testid="interpreter-login-link">
            Interpreter login
          </Link>
        </div>
      </form>
    </div>
  );
}
